import management from './management';

const menuList = {
  items: [management],
};

export default menuList;
